import { useReducer } from 'react';

import type { Lucid } from '../types/types';

const useAbTestReducer = () =>
  useReducer((current: Lucid.ABTest.StateData, next: Lucid.Context.ABTest.Props) => {
    const currentABTestPropKeys = Object.keys(current);

    if (!currentABTestPropKeys.includes(next.testName)) {
      return {
        ...current,
        [next.testName]: next,
      } as Lucid.ABTest.StateData;
    }

    if (currentABTestPropKeys.includes(next.testName)) {
      return {
        ...current,
        [next.testName]: {
          ...current[next.testName],
          ...next,
        },
      } as Lucid.ABTest.StateData;
    }

    return current;
  }, {});

export default useAbTestReducer;
